import { createAsyncThunk } from '@reduxjs/toolkit'
import API from 'utils/api'

export const SERVICE_NOTE_MAX_LENGTH = 60

// Тело ошибки не всегда JSON: обрыв сети реджектит fetch объектом TypeError без
// .json(), а 502/504 от ingress приходят HTML. Тогда отдаём null — текст подставит
// вызывающий код.
const errorMessage = async (err) => {
  if (typeof err?.json !== 'function') return null

  const body = await err.json().catch(() => null)
  return body?.error || body?.message || null
}

// Заметка инженера живёт в ГИС и есть у любого устройства, в списке приходит
// полем alias (business_apps#1472). Заметка для жителей (notice) — отдельное поле.
export const updateServiceNote = createAsyncThunk(
  'devices/updateServiceNote',
  async ({ deviceUuid, type, serviceNote }, { rejectWithValue }) => {
    try {
      const payload = await API.request(`/devices/${deviceUuid}/service_note`, {
        method: 'PATCH',
        body: JSON.stringify({ service_note: serviceNote, type }),
      })
      return { deviceUuid, serviceNote: payload?.service_note ?? null }
    } catch (err) {
      return rejectWithValue(await errorMessage(err))
    }
  }
)
